import { IsString, IsOptional } from 'class-validator';
import { EntityVm } from 'api/core/entity.vm';

export class StationVm extends EntityVm {
  @IsString()
  serverId: string;

  @IsString()
  warehouseId: string;

  @IsString()
  locationId: string;

  @IsOptional()
  @IsString()
  externalId?: string;
}
